import { createApolloClient } from './create-apollo-client'

export const apolloClient = createApolloClient({
  apiUrl: `https://${window.location.hostname}/api/mobile-beef/graphql`,
  wsUrl: `wss://${window.location.hostname}/api/mobile-beef/graphql`,
})
